import { Component, OnInit } from '@angular/core';
import { ConsorciosService } from '../../services/consorcios.service';
import { ArticuloService } from '../../services/articulo.service';
import { Articulo } from '../../model/articulo';
import { Consorcio } from '../../model/consorcio';

import { UtilitiesService } from '../../services/utilities.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { SubirArticulosService } from '../../services/subir-articulos.service';

@Component({
  selector: 'app-articulo-list',
  templateUrl: './articulo-list.component.html',
  styleUrls: ['./articulo-list.component.css']
})

export class ArticuloListComponent implements OnInit {

  public articuloSeleccionado: Articulo;

  public modoEdicion: boolean = false;
  public articulos: Articulo[];
  public consorcio: Consorcio;

  public consorcios: Consorcio[];

  public queryText: string;

  private query: any;

  public ArchivoCargado: boolean = false;
  public NombreArchivo: string = "";
  public csv: any;
  public filtro: string;
  public char_separador: string = ",";

  public buscando: boolean = false;

  constructor(
    private _consorcioService: ConsorciosService,
    private _articuloService: ArticuloService,
    private _utilities: UtilitiesService,
    private _subirArticulosService: SubirArticulosService
  ) {

  }

  ngOnInit() {
    this.filtro = "";
    this.articulos = [];
    this.consorcio = null;

    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }

    this.articuloSeleccionado = new Articulo();
    this.cargarConsorcios();

  }

  cambiarSeparador() {
    if (this.char_separador === ",") {
      this.char_separador = ";";
    } else {
      this.char_separador = ",";
    }
  }

  cargarConsorcios() {

    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => this.consorcios = data,
      err => {
        console.log(err);

      });

  }

  descargarFormato() {
    document.getElementById('Link_File').click();
  }

  cargarArticulos() {

    if (this.consorcio === null) {
      return;
    }

    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "queryText": this.queryText };

    this._articuloService.getArticulos(this.query)
      .subscribe(
      data => this.articulos = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  editarRegistro(_articulo: Articulo) {
    this.articuloSeleccionado = _articulo;
    this.modoEdicion = true;
  }


  agregarRegistro() {
    if (this.consorcio === null) {
      return;
    }

    this.articuloSeleccionado = null;
    this.modoEdicion = true;
  }


  regresar() {
    this.cargarArticulos();
    this.modoEdicion = false;
  }


  buscarArchivo() {
    if (this.consorcio === null) {
      return;
    }
    document.getElementById("Button_File").click();
  }

  prepararEnvio(arrDoc: any, arrSync: any) {
    if (arrSync.length > 0) {
      for (var i = 0; i < arrSync.length; i++) {
        delete arrDoc[this.findIndex(arrDoc, arrSync[i], "ID_SYNC")];
        arrDoc.sort();
        arrDoc.length = arrDoc.length - 1;
      }
    }

    if (arrDoc.length > 0) {

      var arrToSync = [];
      if (arrDoc.length > 30) {
        arrToSync.push(arrDoc[0]);
        arrToSync.push(arrDoc[1]);
        arrToSync.push(arrDoc[2]);
        arrToSync.push(arrDoc[3]);
        arrToSync.push(arrDoc[4]);
        arrToSync.push(arrDoc[5]);
        arrToSync.push(arrDoc[6]);
        arrToSync.push(arrDoc[7]);
        arrToSync.push(arrDoc[8]);
        arrToSync.push(arrDoc[9]);
        arrToSync.push(arrDoc[10]);
        arrToSync.push(arrDoc[11]);
        arrToSync.push(arrDoc[12]);
        arrToSync.push(arrDoc[13]);
        arrToSync.push(arrDoc[14]);
        arrToSync.push(arrDoc[15]);
        arrToSync.push(arrDoc[16]);
        arrToSync.push(arrDoc[17]);
        arrToSync.push(arrDoc[18]);
        arrToSync.push(arrDoc[19]);
        arrToSync.push(arrDoc[20]);
        arrToSync.push(arrDoc[21]);
        arrToSync.push(arrDoc[22]);
        arrToSync.push(arrDoc[23]);
        arrToSync.push(arrDoc[24]);
        arrToSync.push(arrDoc[25]);
        arrToSync.push(arrDoc[26]);
        arrToSync.push(arrDoc[27]);
        arrToSync.push(arrDoc[28]);
        arrToSync.push(arrDoc[29]);
      } else {
        arrToSync = arrDoc;
      }
      this._subirArticulosService.insert(arrToSync)
        .subscribe(
        data => {
          this.prepararEnvio(arrDoc, data.Resultado);
        },
        err => {
          console.log(err._body);
        });
    } else {
      alert("El archivo ha sido cargado...");
      this.buscando = false;
      this.cargarArticulos();
    }


  }

  findIndex(arr, query, property) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (arr[i][property] === query) return i;
    }
    return -1;
  }

  cargarArchivo() {
    this.ArchivoCargado = false;
    var oFReader = new FileReader();
    var retorno = false;

    oFReader.onloadend = (e) => {
      var Lines = oFReader.result.split("\n");
      var Headers = Lines[0].replace(/"/g, '').split(this.char_separador);
      var arr = [];
      for (var i = 1; i < ((Lines.length) - 1); i++) {
 
    
        var Current_Line = Lines[i].replace(/"/g, '').split(this.char_separador);
        var Obj = {};
        Obj["ID_SYNC"] = i;
        Obj["CODIGOCONSORCIO"] = this.consorcio.codigoConsorcio;
        for (var j = 0; j < Headers.length; j++) {
          if (Headers[j] === "UNIDADESPAQUETE" || Headers[j] === "PAQUETESTARIMA" || Headers[j] === "PAQUETESBASETARIMA" || Headers[j] === "PAQUETESALTURATARIMA" || Headers[j] === "PESOPAQUETE" || Headers[j] === "CUBICAJEPAQUETE" || Headers[j] === "DIASCUARENTENA") {
            Obj[Headers[j].replace(/"/g, '')] = parseFloat(Current_Line[j]);
          } else {
            Obj[Headers[j].replace(/"/g, '')] = Current_Line[j];
          }
        }
        if (Obj["CODIGOBARRABULTO"] === Obj["CODIGOBARRAUNIDAD"]) {
          alert("Código Barra Unidad no puede ser igual a Código Barra Bulto");
          return;
        }
        arr.push(Obj);
    
      }

      if (retorno) {
        return;
      } else {
        this.buscando = true;
        this.prepararEnvio(arr, []);
      }
    }
    oFReader.readAsText(this.csv, 'ISO-8859-1');
  }

  onChangeFile(event) {
    this.ArchivoCargado = true;
    var file = event.target.files[0] || event.srcElement.files[0];
    this.NombreArchivo = file.name;
    this.csv = file;
  }

  exportar() {
    var Header = [
      { Title: "CODIGOARTICULO", Value: "codigoArticulo" },
      { Title: "CODIGOCATEGORIA", Value: "codigoCategoria" },
      { Title: "CODIGOSUBCATEGORIA", Value: "codigoSubCategoria" },
      { Title: "REFERENCIAERP", Value: "referenciaERP" },
      { Title: "NOMBRECORTO", Value: "nombreCorto" },
      { Title: "NOMBRELARGO", Value: "nombreLargo" },
      { Title: "NIVELFRAGILIDAD", Value: "nivelFragilidad" },
      { Title: "NIVELPELIGROSIDAD", Value: "nivelPeligrosidad" },
      { Title: "TIPOALMACENAMIENTO", Value: "tipoAlmacenamiento" },
      { Title: "CODIGOBARRAUNIDAD", Value: "codigoBarraUnidad" },
      { Title: "CODIGOBARRABULTO", Value: "codigoBarraBulto" },
      { Title: "CODIGOPROVEEDOR", Value: "codigoProveedor" },
      { Title: "UNIDADBASE", Value: "unidadBase" },
      { Title: "UNIDADPAQUETE", Value: "unidadPaquete" },
      { Title: "UNIDADESPAQUETE", Value: "unidadesPaquete" },
      { Title: "PAQUETESTARIMA", Value: "paquetesTarima" },
      { Title: "PAQUETESBASETARIMA", Value: "paquetesBaseTarima" },
      { Title: "PAQUETESALTURATARIMA", Value: "paquetesAlturaTarima" },
      { Title: "PESOPAQUETE", Value: "pesoPaquete" },
      { Title: "CUBICAJEPAQUETE", Value: "cubicajePaquete" },
      { Title: "DIASCUARENTENA", Value: "diasCuarentena" },
      { Title: "GESTIONLOTE", Value: "gestionLote" },
      { Title: "METODOROTACION", Value: "metodoRotacion" },
      { Title: "CONTROLSERIES", Value: "controlSeries" },
      { Title: "ROWCONTROL", Value: "id" },
    ];

    var ar = [];
    var arr = this.articulos;

    for (var x = 0; x < arr.length; x++) {
      var obj = {};
      for (var j = 0; j < Header.length; j++) {
        obj[Header[j].Title] = arr[x][Header[j].Value];
      }
      ar.push(obj);
    }



    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {
        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";
      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "Articulos" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/articulo-list/articulo-list.component.ts